import React from 'react';

const APIDocumentation: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto py-16 px-4 sm:px-6 lg:px-8">
      <h1 className="text-3xl font-bold mb-8 text-center">API Documentation</h1>
      <div className="space-y-6">
        <div className="bg-white rounded-xl shadow p-6">
          <h2 className="text-xl font-semibold mb-4">Getting Started</h2>
          <p className="text-gray-700">Explore our API documentation for developers.</p>
          <p className="text-gray-700">API coming soon.</p>
        </div>
      </div>
    </div>
  );
};

export default APIDocumentation;
